import axios from '../../utils/axiosConfig';
import config from '../../utils/Config';
import axiosw from 'axios'


let getSurveyData = (districtObj) => {

    console.log(districtObj);
    // console.log(authorization);
    let sendObj = {
        districtId: districtObj.districtId,
        headers: {
            'Content-Type': 'application/json',
            'authorization': districtObj.authorization ? districtObj.authorization : ''
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'survey/getsurveypagedata', sendObj).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}

let saveSurveyPageDate = (surveyData) => {
    return new Promise((resolve, reject) => {
        console.log(surveyData)
        axios.post(config.basePath + 'survey/savesurveypagedata', surveyData).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}

let getSurveyDataPdf = (districtObj, token) => {

    // console.log(districtObj);
    let sendObj = {
        headers: {
            'Content-Type': 'application/json',
            'authorization': token
        }
    }

    // console.log(sendObj);
    return new Promise((resolve, reject) => {
        axiosw.post(config.basePath + 'survey/getsurveypagedata', { districtId: districtObj }, sendObj).then(result => {
            // console.log('result', result);
            resolve(result)
        }).catch((err) => {
            reject(err)
        })

    })

}

const surveyService = {
    saveSurveyPageDate,
    getSurveyData,
    getSurveyDataPdf
}

export default surveyService 